import { formatCurrency, pn, Skeleton, Stack, Typography } from "@compass/core";
import { HomeMatchDashboardRow } from "generated/openApi";
import PieChart, { Series, Size, Tooltip } from "devextreme-react/pie-chart";

export const DashboardPieChart = (props: {
  rows: HomeMatchDashboardRow[] | undefined;
  loading: boolean;
}) => {
  return props.loading ? (
    <Stack direction="row" spacing="lg">
      <Skeleton variant="rounded" width={"70%"} height={400} />
      <Skeleton variant="rounded" width={"30%"} height={200} />
    </Stack>
  ) : (
    <Stack width="100%" height="100%" direction="column" spacing="lg">
      <PieChart
        dataSource={props.rows}
        height="100%"
        onPointHoverChanged={(pointInfo: any) => {
          if (pointInfo.target.isHovered()) {
            pointInfo.target.showTooltip();
          } else {
            pointInfo.target.hideTooltip();
          }
        }}
        palette="Soft Blue"
      >
        <Series
          argumentField={pn<HomeMatchDashboardRow>("label")}
          valueField={pn<HomeMatchDashboardRow>("amount")}
        ></Series>
        <Tooltip
          enabled={false}
          customizeTooltip={(arg) => {
            return {
              text: `${arg.argumentText}: <b>${formatCurrency(Number(arg.valueText))}</b>`,
            };
          }}
        />
      </PieChart>
    </Stack>
  );
};